// import {
//   DesktopOutlined,
//   SettingOutlined,
//   CustomerServiceOutlined,
//   FileTextOutlined,
//   FileSyncOutlined,
//   DashboardOutlined,
//   TeamOutlined,
//   UserOutlined,
//   CreditCardOutlined,
//   BankOutlined,
// } from "@ant-design/icons";

// export const IconMenu = ({ name }) => {
//   const components = {
//     DesktopOutlined: DesktopOutlined,
//     SettingOutlined: SettingOutlined,
//     CustomerServiceOutlined: CustomerServiceOutlined,
//     FileTextOutlined: FileTextOutlined,
//     FileSyncOutlined: FileSyncOutlined,
//     DashboardOutlined: DashboardOutlined,
//     TeamOutlined: TeamOutlined,
//     UserOutlined: UserOutlined,
//     CreditCardOutlined: CreditCardOutlined,
//     BankOutlined: BankOutlined,
//     Default: DesktopOutlined,
//   };

//   const IconTag = components[name || "Default"] || SettingOutlined;
//   return <IconTag />;
// };


export const routesConfig = [
  {
    path: "/",
    component: "Dashboard",
  },
  {
    path: "/reservation",
    component: "Reservation",
  },
  {
    path: "/reservations",
    component: "Reservations",
  },
  {
    path: "/reservations/:reservationKey",
    component: "ReservationDetail",
  },
  {
    path: "/nrvs",
    component: "NRVs",
  },
  {
    path: "/nrvs/new",
    component: "NRVCreate",
  },
  {
    path: "/nrvs/:nrvKey",
    component: "NRVDetail",
  },
  {
    path: "/customer",
    component: "Customer",
  },
  {
    path: "/customers",
    component: "Customers",
  },
  {
    path: "/customers/:customerKey",
    component: "CustomerDetail",
  },
  {
    path: "/car",
    component: "Car",
  },
  {
    path: "/employee",
    component: "Employees",
  },
  {
    path: "/hrm/employees",
    component: "Employees",
  },
  {
    path: "/maintance",
    component: "Maintance",
  },
  {
    path: "/expense_entry",
    component: "Expenses",
  },
  {
    path: "/payment",
    component: "Payment",
  },
  {
    path: "/coin-orders",
    component: "CoinOrders",
  },
  {
    path: "/coin-orders/:orderKey",
    component: "CoinOrderDetail",
  },
  {
    path: "/coin-transfers",
    component: "CoinTransfers",
  },
  {
    path: "/invoices",
    component: "AccountInvoices",
  },
  {
    path: "/invoices/:invoiceId",
    component: "AccountInvoiceDetail",
  },
  {
    path: "/reports/aging",
    component: "AgingReport",
  },
  {
    path: "/reports/revenue",
    component: "RevenueReport",
  },
  {
    path: "/reports/salik",
    component: "SalikReport",
  },
  {
    path: "/reports/app-analytics",
    component: "AppAnalytics",
  },
  {
    path: "/task_management",
    component: "TaskManagement",
  },
  {
    path: "/tasks/board",
    component: "TaskBoard",
  },
  {
    path: "/account/other",
    component: "OtherAccount",
  },
  {
    path: "/transaction",
    component: "Transaction",
  },
  {
    path: "/master/bank-accounts",
    component: "BankAccount",
  },
  {
    path: "/settings",
    component: "Settings",
  },
  {
    path: "/settings/promo-codes",
    component: "PromoCode",
  },
  {
    path: "/settings/notifications",
    component: "NotificationSettings",
  },
  {
    path: "/settings/notification-logs",
    component: "NotificationLogs",
  },
  {
    path: "/hrm/attendance",
    component: "HrmAttendance",
  },
  {
    path: "/hrm/attendance-anomalies",
    component: "HrmAttendanceAnomalies",
  },
  {
    path: "/hrm/leaves",
    component: "HrmLeaves",
  },
  {
    path: "/hrm/leave-summary",
    component: "HrmLeaveSummary",
  },
  {
    path: "/hrm/payroll",
    component: "HrmPayroll",
  },
  {
    path: "/hrm/payroll-anomalies",
    component: "HrmPayrollAnomalies",
  },
  {
    path: "/hrm/payroll/:id",
    component: "HrmPayrollDetail",
  },
  {
    path: "/hrm/advances",
    component: "HrmAdvances",
  },
  {
    path: "/hrm/settings",
    component: "HrmSettings",
  },
  {
    path: "/useractivity",
    component: "UserActivity",
  },
  {
    path: "/addonitem",
    component: "AddOnItem",
  },
  {
    path: "/user_permission",
    component: "UserPermission",
  },
  {
    path: "/transfer_approval",
    component: "CashTransfer",
  },
  {
    path: "/car_maintanance",
    component: "CarMaintanance",
  },
  {
    path: "/salik_list",
    component: "Salik",
  },
  {
    path: "/tap_payments",
    component: "TapPayments",
  },
  {
    path: "/tap_refunds",
    component: "TapRefunds",
  },
  {
    path: "/account/refunds",
    component: "AccountRefunds",
  },
  {
    path: "/parking_list",
    component: "Parking",
  },
  {
    path: "/darb_list",
    component: "Derp",
  },
  {
    path: "/fine_list",
    component: "Fines",
  },
  {
    path: "/availability_list",
    component: "AvailabilityCalender",
  },
  {
    path: "/availability_list_v2",
    component: "AvailabilityCalenderV2",
  },
  {
    path: "/service_data",
    component: "ServiceData",
  },
  {
    path: "/b2b_customer",
    component: "BToBCustomer",
  },
  {
    path: "/vat_export",
    component: "VatExport",
  },
  {
    path: "/notifications",
    component: "Notifications",
  },
  {
    path: "/notifications/broadcast",
    component: "BroadcastNotifications",
  },
];
